<template>
  <div class="site-wrap">
    <div class="site-mobile-menu site-navbar-target">
      <div class="site-mobile-menu-header">
        <div class="site-mobile-menu-close">
          <span class="icon-close2 js-menu-toggle"></span>
        </div>
      </div>
      <div class="site-mobile-menu-body"></div>
    </div>
    <NavBar @login="$emit('login')" @register="$emit('register')" />
    <section class="home-section bg-dark overlay" id="home-section">
      <div class="ban">
        <div class="container"></div>
      </div>
    </section>
    <section class="site-section" id="joblist" style="background: #f8f8fb">
      <div>
        <!-- v-if="$route.query.page == 'login'"  -->
        <Login/>
        <!-- <Register v-else-if="$route.query.page == 'register'" /> -->
      </div>
    </section>
  </div>
</template>

<script>
import NavBar from "@/views/NavBar.vue";
import Login from "./login";
import Register from "./registration";

export default {
  name: "home",
  data() {
    return {};
  },
  methods: {},
  components: {
    NavBar,
    Register,
    Login,
  },
 
};
</script>

<style>
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .ban {
    height: 25vh !important;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (max-width: 992px) {
  .ban {
    height: 25vh !important;
  }
}
.ban {
  width: 100%;
  height: 10vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ban img {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.ban .container {
  position: relative;
  z-index: 1;
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}
</style>
